// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: 0Avth2hHpq79
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import SignOutElement from "../../SignOutElement"; // plasmic-import: oUG6N5k-MozB/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicProfileStack.module.css"; // plasmic-import: 0Avth2hHpq79/css
import GroupIcon from "./icons/PlasmicIcon__Group"; // plasmic-import: YctzKJSFJvt3/icon

createPlasmicElementProxy;

export const PlasmicProfileStack__VariantProps = new Array("postClick");

export const PlasmicProfileStack__ArgProps = new Array();

const $$ = {};

function PlasmicProfileStack__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "postClick",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.postClick
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root,
        { [sty.rootpostClick]: hasVariant($state, "postClick", "postClick") }
      )}
    >
      <GroupIcon
        data-plasmic-name={"profileButton"}
        data-plasmic-override={overrides.profileButton}
        className={classNames(projectcss.all, sty.profileButton, {
          [sty.profileButtonpostClick]: hasVariant(
            $state,
            "postClick",
            "postClick"
          )
        })}
        role={"img"}
      />

      {(hasVariant($state, "postClick", "postClick") ? true : false) ? (
        <SignOutElement
          data-plasmic-name={"signOutButton"}
          data-plasmic-override={overrides.signOutButton}
          className={classNames("__wab_instance", sty.signOutButton, {
            [sty.signOutButtonpostClick]: hasVariant(
              $state,
              "postClick",
              "postClick"
            )
          })}
          postClick={
            hasVariant($state, "postClick", "postClick") ? true : undefined
          }
        />
      ) : null}
      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames(projectcss.all, sty.freeBox)}
      >
        <div
          data-plasmic-name={"text"}
          data-plasmic-override={overrides.text}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text
          )}
        >
          <React.Fragment>
            <span
              className={"plasmic_default__all plasmic_default__span"}
              style={{ color: "#FFFBFB" }}
            >
              {"Profile"}
            </span>
          </React.Fragment>
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root", "profileButton", "signOutButton", "freeBox", "text"],
  profileButton: ["profileButton"],
  signOutButton: ["signOutButton"],
  freeBox: ["freeBox", "text"],
  text: ["text"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicProfileStack__ArgProps,
          internalVariantPropNames: PlasmicProfileStack__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicProfileStack__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicProfileStack";
  } else {
    func.displayName = `PlasmicProfileStack.${nodeName}`;
  }
  return func;
}

export const PlasmicProfileStack = Object.assign(
  // Top-level PlasmicProfileStack renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    profileButton: makeNodeComponent("profileButton"),
    signOutButton: makeNodeComponent("signOutButton"),
    freeBox: makeNodeComponent("freeBox"),
    text: makeNodeComponent("text"),
    // Metadata about props expected for PlasmicProfileStack
    internalVariantProps: PlasmicProfileStack__VariantProps,
    internalArgProps: PlasmicProfileStack__ArgProps
  }
);

export default PlasmicProfileStack;
/* prettier-ignore-end */
